define('uikit/modules/token',['require','exports','module','underscore','backbone','../elements/label','../extra/key.codes','../helper/dom','../templates'],function(require, exports, module){
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Label = require('../elements/label');
  var KeyCodes = require('../extra/key.codes');
  var DOMHelper = require('../helper/dom');
  var Templates = require('../templates');

  var TokenView = Label.extend({

    template: Templates.UIKit['token'],

    options: _.extend({}, Label.prototype.options, {
      single: true,
      editing: false,
      selected: false,
      separator: ':',
      icon: 'remove circle'
    }),

    forceUpdate: _.extend({}, Label.prototype.forceUpdate, {
      single: true,
      icon: true
    }),

    bindings: {
      text:   'text',
      title: 'title',
      detail: 'value'
    },

    ui: {
      text    : '.text',
      detail  : '.detail'
    },

    events: {
      'keydown'                   : 'handleKeydown',
      'keyup @ui.detail'          : 'handleKeyupOnDetail',
      'keydown @ui.detail'        : 'handleKeydownOnDetail'
    },

    triggers: {
      'blur'                      : 'deselect',
      'blur .detail'              : 'not:editing deselect complete',
      'focus'                     : 'selected',
      'focus .detail'             : 'editing',
      'click .icon.remove.circle' : 'close'
    },

    completeEdit: function() {
      this.ui.detail.blur();
    },

    setCursorToStart: function() {
      var el = this.ui.detail.get(0);

      DOMHelper.placeCaretAtStart(el);
    },

    setCursorToEnd: function() {
      var el = this.ui.detail.get(0);

      DOMHelper.placeCaretAtEnd(el);
    },

    setDetail: function(text) {
      // Cache the details initially
      if (this._cachedDetail == null) {
        this._cachedDetail = this.detail;
      }

      this.detail = text;

      this.setCursorToEnd();
    },

    resetDetail: function() {
      // Set detail to the cached version
      this.setDetail(this._cachedDetail || '');

      this._cachedDetail = null;
    },

    setFocus: function() {
      this.$el.focus();
      return this;
    },

    setFocusOnEdit: function() {
      // todo - depends on single or dual value
      this.ui.detail.focus();
    },

    removeAllFocus: function() {
      DOMHelper.clearSelection();
    },

    handleKeydown: function(ev) {
      if (this.el == ev.target) { // Only apply if parent element in focus
        if (ev.keyCode === KeyCodes.BACKSPACE_KEY || ev.keyCode === KeyCodes.DELETE_KEY) {
          ev.preventDefault();
          this.triggerMethod('close');
        }
      }
    },

    handleKeydownOnDetail: function(ev) {
      var self       = this,
          keyCode    = ev.keyCode,
          cursorPos  = DOMHelper.cursorPosition(),
          caretStart = cursorPos.caretStart,
          caretEnd   = cursorPos.caretEnd,
          selLength  = cursorPos.selectionLength,
          oldValue   = ev.target.textContent;

      if (selLength) {
        ev.stopPropagation();
      }

      // Prevent the enter key from inserting a break line character
      if (keyCode === KeyCodes.ENTER_KEY) {
        ev.preventDefault();

      // Prevent the tab key from propagating a tab to the next focused item
      } else if (keyCode === KeyCodes.TAB_KEY) {
        (this.getOption('selectValueOnTab')) ? ev.preventDefault() : ev.stopPropagation();

      // TODO - Prevent right arrow key from what?
      } else if (keyCode === KeyCodes.RIGHTARROW_KEY && caretStart !== this.detail.length) {
        ev.stopPropagation();

      // TODO - Prevent left arrow key from what?
      } else if (keyCode === KeyCodes.LEFTARROW_KEY && caretStart !== 0) {
        ev.stopPropagation();

      // Prevent the down and up arrows keys default behaviors
      } else if (keyCode === KeyCodes.DOWNARROW_KEY || keyCode == KeyCodes.UPARROW_KEY) {
        ev.preventDefault();

      // When backspacing after the last character, select the entire token
      } else if (keyCode === KeyCodes.BACKSPACE_KEY && caretStart == 0 && !selLength) {
        ev.preventDefault();

        this.removeAllFocus();

        this.setFocus();
      } else {
        _.defer(function() {
          // Avoid setting off change event because of other key codes
          if (oldValue !== ev.target.textContent) {
            self._cachedDetail = ev.target.textContent;

            self._setOption('detail', ev.target.textContent, { internal: true });

            self.triggerMethod('value:edit', ev.target.textContent);
          }
        });
      }
    },

    handleKeyupOnDetail: function(ev) {
      if (ev.keyCode === KeyCodes.ENTER_KEY) {
        this._setOption('detail', ev.target.textContent, { internal: true });
      }

      this.triggerMethod('keypress', ev)
    },

    onRender: function() {
      if (this.getBoolOption('single')) {
        // this.ui.text.attr('contentEditable', 'true');
      } else {
        this.ui.detail.attr('contentEditable', 'true');
      }
    },

    onComplete: function() {
      this._cachedDetail = null;
    },

    updateAttributes: function() {
      Label.prototype.updateAttributes.apply(this, arguments);

      this.addClass('selected', this.getBoolOption('selected'));
      this.addClass('editing', this.getBoolOption('editing'));

      if (this.title) {
        this.$el.popup({
          variation: 'inverted',
          content: this.title
        });
      } else {
        this.$el.popup('destroy');
      }

      this.$el.attr('tabindex', -1);

      if (this.ui.detail) {
        this.ui.detail.text(this.getOption('detail'));
      }
    },

    onDestroy: function() {
      this.$el.popup('destroy');
    }

  });

  module.exports = TokenView;
});

